export default "__VITE_ASSET__DCznxgg9__"